import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

import { FsNavModule } from '@firestitch/nav';

import { NavService } from '@common/services';


import { AccountMenuComponent } from '../account-menu';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    NgTemplateOutlet,
    FsNavModule,
    AccountMenuComponent,
  ],
})
export class NavbarComponent {

  /** Markup the open view wants rendered beside the title, if any. */
  public titleTemplate = inject(NavService).titleTemplate;

}
